import { render, staticRenderFns } from "./TenderTable.vue?vue&type=template&id=4d5a5e59&"
import script from "./TenderTable.vue?vue&type=script&lang=js&"
export * from "./TenderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports